import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AdsClickIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ads_click"}/>
}
